import React, { useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../../utils/utils";
import useReckonApi from "../../hooks/useReckonApi";
import useMixpanelEventAction from "../../config/mixpanel/useMixpanelEventAction";
import useGA4EventAction from "../../config/GoogleAnalytics/useGA4EventAction";
import { callBackComp, commonErrMsg, invcsConnect } from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import { INVOICE } from "../../route/paths";

const ReckonCallBack = () => {
  const navigate = useNavigate();
  const initialRender = useRef(true);
  const { ReckonCallBack } = useReckonApi();
  const { reckonConnectMixpanelEvent } = useMixpanelEventAction();
  const { reckonConnectGA4Event } = useGA4EventAction();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeParams = queryParams.get("code");
  const stateParams = queryParams.get("state");

  const handleReckonCallBack = useCallback(async () => {
    try {
      const response = await ReckonCallBack({
        code: codeParams,
        state: stateParams
      });

      await reckonConnectGA4Event();
      if (!response.data.data.BookIdDetails) {
        reckonConnectMixpanelEvent();
        showToast(commonErrMsg.reckonSuccess, showToastType.success);
      }

      navigate(INVOICE, {
        state: {
          BookIdDetails: response.data.data.BookIdDetails
            ? response.data.data.BookIdDetails
            : null,
          softwareType: "RECKON"
        }
      });
    } catch (err) {
      console.error(invcsConnect.errMsg.item1, err);
      navigate(INVOICE);
      showToast(
        err?.response?.data?.message || commonErrMsg?.organisationNotFound,
        showToastType.error
      );
    }
  }, [
    ReckonCallBack,
    codeParams,
    navigate,
    stateParams,
    reckonConnectMixpanelEvent,
    reckonConnectGA4Event
  ]);

  useEffect(() => {
    if (initialRender.current) {
      handleReckonCallBack();
      initialRender.current = false;
    }
  }, [handleReckonCallBack]);

  return <h5 className="text-dark">{callBackComp.doNotRefresh}</h5>;
};

export default ReckonCallBack;
